import React, { useEffect, useMemo, useState } from "react";
import { collection, doc, onSnapshot, setDoc } from "firebase/firestore";
import { db } from "../firebase";
import Gala from "../components/gala";

const FACILITY_ID = "SPdqELFz2ovWSn8eFyws";

export default function GalaList({ isToogle }) {
  const [users, setUsers] = useState([]);
  const [groups, setGroups] = useState([]);
  const [locations, setLocations] = useState([]);
  const [confirmGroup, setConfirmGroup] = useState(null);

  useEffect(() => {
    const unsub = onSnapshot(collection(db, "users2026"), (snapshot) => {
      const data = snapshot.docs.map((doc) => doc.data()) || [];
      const clients = [];

      for (let i = 0; i < data.length; i++) {
        const subUsers = Object.values(data[i]?.subUsers || {});
        for (let x = 0; x < subUsers.length; x++) {
          clients.push({
            uid: data[i]?.uid,
            acc: data[i],
            user: subUsers[x],
          });
        }
      }

      setUsers(clients);
    });

    return () => unsub();
  }, []);

  useEffect(() => {
    const unsub = onSnapshot(doc(db, "groups", FACILITY_ID), (snapshot) => {
      const data = snapshot.data() || {};
      const groupsArr = Object.entries(data).map(([id, value]) => ({
        id,
        ...value,
      }));
      setGroups(groupsArr);
    });

    return () => unsub();
  }, []);

  useEffect(() => {
    const unsub = onSnapshot(collection(db, "locations"), (snapshot) => {
      const data = snapshot.docs.map((doc) => doc.data()) || [];
      const flat = [];
      data.forEach((locationDoc) => {
        flat.push(...Object.values(locationDoc || {}));
      });
      setLocations(flat);
    });

    return () => unsub();
  }, []);

  const numberToPolishWeekday = (num) => {
    const days = {
      1: "Poniedziałek",
      2: "Wtorek",
      3: "Środa",
      4: "Czwartek",
      5: "Piątek",
      6: "Sobota",
      7: "Niedziela",
    };
    return days[num] || "";
  };

  const activeGroupIds = useMemo(() => {
    return new Set(
      groups
        .filter((g) => g?.gala !== false)
        .map((g) => g.id)
        .filter(Boolean)
    );
  }, [groups]);

  const getUserGalaStatus = (u) => {
    const prices = u?.user?.prices;
    const gala = u?.user?.gala;

    if (!prices || typeof prices !== "object") return "black";

    const groupIds = Object.keys(prices).filter((groupId) => activeGroupIds.has(groupId));
    if (!groupIds.length) return "black";

    if (!gala || typeof gala !== "object") return "black";

    const statuses = groupIds.map((groupId) => gala[groupId]);

    const isNone = (v) => v === undefined || v === null || v === "" || v === "none";

    const allNone = statuses.every((v) => isNone(v));
    if (allNone) return "black";

    const allTrue = statuses.every((v) => v === true);
    if (allTrue) return "green";

    const allFalse = statuses.every((v) => v === false);
    if (allFalse) return "red";

    return "yellow";
  };

  const getSingleGroupGalaStatus = (u, groupId) => {
  const value = u?.user?.gala?.[groupId];

  if (value === true) return "green";
  if (value === false) return "red";
  return "black";
};

  const isJastrzebieLocation = (locationName = "") => {
    const name = String(locationName).toLowerCase();
    return (
      name.includes("mszana") ||
      name.includes("północna") ||
      name.includes("harcerska")
    );
  };

  const getGroupLabel = (group) => {
    const locationName =
      locations?.find((x) => x?.id === group?.location_id)?.name || "Brak lokalizacji";

    const firstDay = Array.isArray(group?.days) ? group?.days?.[0] : group?.days;

    const dayInfo = firstDay?.custom_name
      ? firstDay.custom_name
      : `${numberToPolishWeekday(firstDay?.weekDay)} ${firstDay?.startTime || ""} - ${firstDay?.endTime || ""}`;

    return `${locationName} - ${group?.type || ""} - ${dayInfo}`;
  };

  const markGroupAsHiddenFromGala = async (groupId) => {
    if (!groupId) return;

    try {
      await setDoc(
        doc(db, "groups", FACILITY_ID),
        {
          [groupId]: {
            gala: false,
          },
        },
        { merge: true }
      );
      setConfirmGroup(null);
    } catch (error) {
      console.error("Błąd przy oznaczaniu grupy gala:false", error);
    }
  };

  const groupsSummary = useMemo(() => {
    if (!groups?.length) return [];

    return groups
      .map((group) => {
        const locationName =
          locations?.find((x) => x?.id === group?.location_id)?.name || "Brak lokalizacji";

        return {
          ...group,
          locationName,
          label: getGroupLabel(group),
        };
      })
      .map((group) => {
        const usersInGroup = users.filter((u) => u?.user?.groups?.includes(group?.id));

        let green = 0;
        let red = 0;
        let black = 0;
        let yellow = 0;

usersInGroup.forEach((u) => {
  const status = getSingleGroupGalaStatus(u, group.id);

  if (status === "green") green += 1;
  else if (status === "red") red += 1;
  else if (status === "black") black += 1;
  else if (status === "yellow") yellow += 1;
});

        return {
          ...group,
          total: usersInGroup.length,
          green,
          red,
          black,
          yellow,
        };
      })
      .sort((a, b) => a.label.localeCompare(b.label, "pl"));
  }, [groups, users, locations]);

  const jastrzebieGroups = useMemo(() => {
    return groupsSummary.filter((group) => isJastrzebieLocation(group.locationName));
  }, [groupsSummary]);

  const wroclawGroups = useMemo(() => {
    return groupsSummary.filter((group) => !isJastrzebieLocation(group.locationName));
  }, [groupsSummary]);

  const jastrzebieActiveGroups = useMemo(() => {
    return jastrzebieGroups.filter((group) => group?.gala !== false);
  }, [jastrzebieGroups]);

  const jastrzebieHiddenGroups = useMemo(() => {
    return jastrzebieGroups.filter((group) => group?.gala === false);
  }, [jastrzebieGroups]);

  const wroclawActiveGroups = useMemo(() => {
    return wroclawGroups.filter((group) => group?.gala !== false);
  }, [wroclawGroups]);

  const wroclawHiddenGroups = useMemo(() => {
    return wroclawGroups.filter((group) => group?.gala === false);
  }, [wroclawGroups]);

  const jastrzebieSummary = useMemo(() => {
    return jastrzebieActiveGroups.reduce(
      (acc, group) => {
        acc.groups += 1;
        acc.total += group.total || 0;
        acc.green += group.green || 0;
        acc.red += group.red || 0;
        acc.yellow += group.yellow || 0;
        acc.black += group.black || 0;
        return acc;
      },
      { groups: 0, total: 0, green: 0, red: 0, yellow: 0, black: 0 }
    );
  }, [jastrzebieActiveGroups]);

  const wroclawSummary = useMemo(() => {
    return wroclawActiveGroups.reduce(
      (acc, group) => {
        acc.groups += 1;
        acc.total += group.total || 0;
        acc.green += group.green || 0;
        acc.red += group.red || 0;
        acc.yellow += group.yellow || 0;
        acc.black += group.black || 0;
        return acc;
      },
      { groups: 0, total: 0, green: 0, red: 0, yellow: 0, black: 0 }
    );
  }, [wroclawActiveGroups]);

  const renderGroupRow = (group) => (
    <div
      key={group.id}
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "20px",
        padding: "14px 16px",
        border: "1px solid rgb(30,30,30,0.15)",
        borderRadius: "8px",
        backgroundColor: "#fff",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: "4px",
          width: "45%",
        }}
      >
        <h3 style={{ fontSize: "14px", color: "rgb(30,30,30)", margin: 0 }}>
          {group.label}
        </h3>
        <h3 style={{ fontSize: "12px", color: "rgb(30,30,30,0.65)", margin: 0 }}>
          Łącznie osób: {group.total}
        </h3>
        <h3 style={{ fontSize: "12px", color: "rgb(30,30,30,0.65)", margin: 0 }}>
          {group.id}
        </h3>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          gap: "18px",
          flexWrap: "wrap",
          width: "35%",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <Gala wth={"20px"} color="#2e9428" curs={"default"} />
          <span style={{ fontSize: "13px", color: "rgb(30,30,30)" }}>{group.green}</span>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <Gala wth={"20px"} color="#DC143C" curs={"default"} />
          <span style={{ fontSize: "13px", color: "rgb(30,30,30)" }}>{group.red}</span>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <Gala wth={"20px"} color="rgb(30,30,30)" curs={"default"} />
          <span style={{ fontSize: "13px", color: "rgb(30,30,30)" }}>{group.black}</span>
        </div>
{/* 
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <Gala wth={"20px"} color="#e0b531" curs={"default"} />
          <span style={{ fontSize: "13px", color: "rgb(30,30,30)" }}>{group.yellow}</span>
        </div> */}
      </div>

      <div
        style={{
          width: "20%",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <button
          onClick={() => setConfirmGroup(group)}
          style={{
            fontSize: "12px",
            color: "white",
            borderRadius: "5px",
            backgroundColor: "#DC143C",
            border: "2px solid #DC143C",
            fontWeight: "bold",
            padding: "8px 12px",
            cursor: "pointer",
          }}
        >
          Usuń z listy
        </button>
      </div>
    </div>
  );

  const renderHiddenGroupRow = (group) => (
    <div
      key={group.id}
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "20px",
        padding: "14px 16px",
        border: "1px solid rgba(30,30,30,0.10)",
        borderRadius: "8px",
        backgroundColor: "rgb(245,245,245)",
        opacity: 0.6,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: "4px",
          width: "45%",
        }}
      >
        <h3 style={{ fontSize: "14px", color: "rgb(30,30,30)", margin: 0 }}>
          {group.label}
        </h3>
        <h3 style={{ fontSize: "12px", color: "rgb(30,30,30,0.65)", margin: 0 }}>
          Łącznie osób: {group.total}
        </h3>
        <h3 style={{ fontSize: "12px", color: "rgb(30,30,30,0.65)", margin: 0 }}>
          {group.id}
        </h3>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          gap: "18px",
          flexWrap: "wrap",
          width: "35%",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <Gala wth={"20px"} color="#2e9428" curs={"default"} />
          <span style={{ fontSize: "13px", color: "rgb(30,30,30)" }}>{group.green}</span>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <Gala wth={"20px"} color="#DC143C" curs={"default"} />
          <span style={{ fontSize: "13px", color: "rgb(30,30,30)" }}>{group.red}</span>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <Gala wth={"20px"} color="rgb(30,30,30)" curs={"default"} />
          <span style={{ fontSize: "13px", color: "rgb(30,30,30)" }}>{group.black}</span>
        </div>
{/* 
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <Gala wth={"20px"} color="#e0b531" curs={"default"} />
          <span style={{ fontSize: "13px", color: "rgb(30,30,30)" }}>{group.yellow}</span>
        </div> */}
      </div>

      <div
        style={{
          width: "20%",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <h3 style={{ fontSize: "12px", color: "rgb(30,30,30,0.6)", margin: 0 }}>
          Ukryta
        </h3>
      </div>
    </div>
  );

  return (
    <div
      className={isToogle ? "side-toogle-margin" : "side-margin"}
      style={{
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        flexDirection: "column",
        minHeight: "100vh",
        overflowY: "scroll",
        gap: "20px",
        paddingTop: "20px",
        paddingBottom: "20px",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "center",
          width: "100%",
          gap: "16px",
        }}
      >
        <h2 style={{ fontSize: "22px", color: "rgb(30,30,30)" }}>
          Gala – podsumowanie grup
        </h2>

        <div
          style={{
            width: "92%",
            maxWidth: "1200px",
            display: "flex",
            flexDirection: "column",
            gap: "26px",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            <h3 style={{ fontSize: "18px", color: "rgb(30,30,30)", margin: 0 }}>
              Jastrzębie
            </h3>

            {jastrzebieActiveGroups.map(renderGroupRow)}

            {jastrzebieHiddenGroups.length > 0 && (
              <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginTop: "8px" }}>
                <h3 style={{ fontSize: "14px", color: "rgb(30,30,30,0.55)", margin: 0 }}>
                  Ukryte grupy
                </h3>
                {jastrzebieHiddenGroups.map(renderHiddenGroupRow)}
              </div>
            )}

            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "18px",
                padding: "12px 14px",
                border: "1px solid rgb(30,30,30,0.12)",
                borderRadius: "8px",
                backgroundColor: "rgb(248,248,248)",
                marginTop: "6px",
              }}
            >
              <h3 style={{ fontSize: "13px", color: "rgb(30,30,30)", margin: 0 }}>
                Grupy: <b>{jastrzebieSummary.groups}</b>
              </h3>

              <h3 style={{ fontSize: "13px", color: "rgb(30,30,30)", margin: 0 }}>
                Uczestnicy: <b>{jastrzebieSummary.total}</b>
              </h3>

              <h3 style={{ fontSize: "13px", color: "#2e9428", margin: 0 }}>
                Występuje: <b>{jastrzebieSummary.green}</b>
              </h3>

              <h3 style={{ fontSize: "13px", color: "#DC143C", margin: 0 }}>
                Nie występuje: <b>{jastrzebieSummary.red}</b>
              </h3>
{/* 
              <h3 style={{ fontSize: "13px", color: "#e0b531", margin: 0 }}>
                Żółte: <b>{jastrzebieSummary.yellow}</b>
              </h3> */}

              <h3 style={{ fontSize: "13px", color: "rgb(30,30,30)", margin: 0 }}>
                Brak deklaracji: <b>{jastrzebieSummary.black}</b>
              </h3>
            </div>
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            <h3 style={{ fontSize: "18px", color: "rgb(30,30,30)", margin: 0 }}>
              Wrocław
            </h3>

            {wroclawActiveGroups.map(renderGroupRow)}

            {wroclawHiddenGroups.length > 0 && (
              <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginTop: "8px" }}>
                <h3 style={{ fontSize: "14px", color: "rgb(30,30,30,0.55)", margin: 0 }}>
                  Ukryte grupy
                </h3>
                {wroclawHiddenGroups.map(renderHiddenGroupRow)}
              </div>
            )}

            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "18px",
                padding: "12px 14px",
                border: "1px solid rgb(30,30,30,0.12)",
                borderRadius: "8px",
                backgroundColor: "rgb(248,248,248)",
                marginTop: "6px",
              }}
            >
              <h3 style={{ fontSize: "13px", color: "rgb(30,30,30)", margin: 0 }}>
                Grupy: <b>{wroclawSummary.groups}</b>
              </h3>

              <h3 style={{ fontSize: "13px", color: "rgb(30,30,30)", margin: 0 }}>
                Uczestnicy: <b>{wroclawSummary.total}</b>
              </h3>

              <h3 style={{ fontSize: "13px", color: "#2e9428", margin: 0 }}>
                Występuje: <b>{wroclawSummary.green}</b>
              </h3>

              <h3 style={{ fontSize: "13px", color: "#DC143C", margin: 0 }}>
                Nie występuje: <b>{wroclawSummary.red}</b>
              </h3>

              {/* <h3 style={{ fontSize: "13px", color: "#e0b531", margin: 0 }}>
                Żółte: <b>{wroclawSummary.yellow}</b>
              </h3> */}

              <h3 style={{ fontSize: "13px", color: "rgb(30,30,30)", margin: 0 }}>
                Brak deklaracji: <b>{wroclawSummary.black}</b>
              </h3>
            </div>
          </div>
        </div>

        <h3 style={{ fontSize: "12px", color: "rgb(30,30,30,0.6)" }}>
          Ilość grup: {groupsSummary.length}
        </h3>
      </div>

      {confirmGroup && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.45)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 50,
          }}
        >
          <div
            style={{
              width: "90%",
              maxWidth: "520px",
              backgroundColor: "#fff",
              borderRadius: "10px",
              padding: "24px",
              display: "flex",
              flexDirection: "column",
              gap: "16px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
            }}
          >
            <h3 style={{ fontSize: "20px", color: "rgb(30,30,30)", margin: 0 }}>
              Potwierdzenie
            </h3>

            <h3 style={{ fontSize: "14px", color: "rgb(30,30,30)", fontWeight: "normal", margin: 0, lineHeight: 1.5 }}>
              Czy na pewno chcesz usunąć tę grupę z listy gali?
            </h3>

            <h3 style={{ fontSize: "14px", color: "#0045C7", margin: 0 }}>
              {confirmGroup.label || getGroupLabel(confirmGroup)}
            </h3>

            <h3 style={{ fontSize: "12px", color: "rgb(30,30,30,0.7)", fontWeight: "normal", margin: 0 }}>
              Ta operacja nie usuwa grupy z systemu. Ustawi tylko status <b>gala: false</b>.
            </h3>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: "10px",
                marginTop: "8px",
              }}
            >
              <button
                onClick={() => setConfirmGroup(null)}
                style={{
                  fontSize: "12px",
                  color: "rgb(30,30,30)",
                  borderRadius: "5px",
                  backgroundColor: "#fff",
                  border: "1px solid rgb(30,30,30,0.2)",
                  fontWeight: "bold",
                  padding: "9px 14px",
                  cursor: "pointer",
                }}
              >
                Anuluj
              </button>

              <button
                onClick={() => markGroupAsHiddenFromGala(confirmGroup.id)}
                style={{
                  fontSize: "12px",
                  color: "white",
                  borderRadius: "5px",
                  backgroundColor: "#DC143C",
                  border: "2px solid #DC143C",
                  fontWeight: "bold",
                  padding: "9px 14px",
                  cursor: "pointer",
                }}
              >
                Potwierdź usunięcie z listy
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}